import React from "react";
import { Button, Form, FormGroup, Input, Label, Alert, Spinner } from "reactstrap";
import axios from "axios";
import { API_URL_instructores, API_URL_partners } from "../../../constants";
import emailjs from "@emailjs/browser";
import Select, { createFilter } from "react-select";
import { recomputeAsignacionUtilidades } from "../../../utils/asignacion-utilidad";
import { getAuthHeaders } from "../../../utils/auth";

class ProyectoIngresoFrom extends React.Component {
  state = {
    pk: 0,
    errorMessage: "",
    instructor: "",
    miembro_que_asigna: "",
    proyecto_code: "",
    observaciones: "",
    totalIncome: "",
    totalCost: "",
    profitability: "",
    horas: "",
    tarifa_hora: "",
    costo_hora: "",
    moneda: "",
    tipo_cambio: "",
    semanas: "",
    partners: [],
    validationErrors: {},
    isSubmitting: false,
  };

  // --- helper: normalize proyecto code from props/state ---
  getProyectoCode = () =>
    this.state.proyecto_code ||
    this.props.proyecto_code ||
    this.props.proyectoCode ||
    this.props.proyectoCodeSelected ||
    this.props.selectedProyecto?.proyecto_code ||
    "";

  componentDidMount() {
    // Inherit currency from project
    const proyectoMoneda = this.props.proyectoMoneda || 'USD';

    // Taller por herramienta: prellenar las horas con la duración del catálogo
    // (editable). Solo al crear, nunca al editar un registro existente.
    const duracionTaller = Number(this.props.selectedProyecto?.cp_subproducto_duracion_horas || 0);
    if (!this.props.instructor && duracionTaller > 0) {
      this.setState({ horas: duracionTaller, semanas: this.state.semanas || 1 }, () => {
        this.calculateTotal();
        this.calculateTotalCost();
        this.calculateProfitability();
      });
    }

    // If editing, hydrate from the instructor prop
    if (this.props.instructor) {
      const {
        pk,
        instructor,
        proyecto_code,
        miembro_que_asigna,
        horas,
        tarifa_hora,
        costo_hora,
        tipo_cambio,
        semanas,
        observaciones,
        totalIncome,
        totalCost,
        profitability,
      } = this.props.instructor;

      const normalizedProyecto = proyecto_code || this.getProyectoCode();

      this.setState(
        {
          pk,
          instructor,
          proyecto_code: normalizedProyecto,
          miembro_que_asigna,
          horas,
          tarifa_hora,
          costo_hora,
          moneda: proyectoMoneda, // Use project currency
          tipo_cambio: tipo_cambio ?? "",
          semanas,
          observaciones,
          totalIncome,
          totalCost,
          profitability,
        },
        () => {
          this.calculateTotal();
          this.calculateTotalCost();
          this.calculateProfitability();
        }
      );
    } else {
      // If creating, still set proyecto_code and moneda immediately
      const normalizedProyecto = this.getProyectoCode();
      this.setState({
        proyecto_code: normalizedProyecto,
        moneda: proyectoMoneda  // Use project currency
      });
    }

    // Load partners
    const headers = getAuthHeaders();

    axios
      .get(API_URL_partners, { headers })
      .then((response) => {
        const partners = response.data || [];
        this.setState({ partners });
      })
      .catch((error) => {
        console.error("Error fetching partners:", error);
      });

    console.log("[IngresoFrom] proyecto_code (on mount):", this.getProyectoCode());
  }

  // ----- helpers for react-select -----
  partnerOptions = () => {
    const { partners = [] } = this.state;
    return Array.isArray(partners)
      ? partners
          .slice()
          .sort((a, b) => (a.partner || "").localeCompare(b.partner || ""))
          .map((p) => ({ value: p.partner, label: p.partner }))
      : [];
  };

  handleSelectInstructor = (opt) => {
    this.setState({
      instructor: opt ? opt.value : "",
      validationErrors: { ...this.state.validationErrors, instructor: null }
    }, () => {
      this.calculateTotal();
      this.calculateTotalCost();
      this.calculateProfitability();
    });
  };

  handleSelectMiembroAsigna = (opt) => {
    this.setState({
      miembro_que_asigna: opt ? opt.value : "",
      validationErrors: { ...this.state.validationErrors, miembro_que_asigna: null }
    }, () => {
      this.calculateTotal();
      this.calculateTotalCost();
      this.calculateProfitability();
    });
  };

  onChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      validationErrors: { ...this.state.validationErrors, [name]: null }
    }, () => {
      this.calculateTotal();
      this.calculateTotalCost();
      this.calculateProfitability();
    });
  };

  validateForm = () => {
    const errors = {};
    const { instructor, miembro_que_asigna, horas, tarifa_hora, semanas, costo_hora } = this.state;

    if (!instructor || instructor.trim() === '') {
      errors.instructor = 'Por favor selecciona un instructor';
    }

    if (!miembro_que_asigna || miembro_que_asigna.trim() === '') {
      errors.miembro_que_asigna = 'Por favor selecciona el partner que provee instructor';
    }

    if (!horas || horas === '') {
      errors.horas = 'Por favor ingresa las horas por semana';
    }

    if (tarifa_hora === '' || tarifa_hora === null || tarifa_hora === undefined) {
      errors.tarifa_hora = 'Por favor ingresa el precio por hora';
    }

    if (!semanas || semanas === '') {
      errors.semanas = 'Por favor ingresa el número de semanas';
    }

    if (costo_hora === '' || costo_hora === null || costo_hora === undefined) {
      errors.costo_hora = 'Por favor ingresa el costo por hora';
    }

    // moneda validation removed - inherited from project

    this.setState({ validationErrors: errors });
    return Object.keys(errors).length === 0;
  };

  sendEmail = (e) => {
    e.preventDefault();
    const { instructor, horas, costo_hora, moneda, semanas, observaciones } = this.state;
    const proyectoNameFrom = this.props.proyectoName;

    const emailParams = {
      to_email: "bgonzalez@leansixsigmainstitute.org",
      from_name: "Salvador Sanchez",
      to_name: "Bernardo",
      reply_to: "bgonzalez@leansixsigmainstitute.org",
      instructor,
      horas,
      costo_hora,
      moneda,
      semanas,
      observaciones,
      proyectoNameFrom,
    };

    emailjs
      .send("service_vzlc6dt", "template_he5jinj", emailParams, "VBYWnQsgbxRBcGQ8N")
      .then((result) => console.log(result.text))
      .catch((error) => console.log(error.text));
  };

  // ---- CREATE ----
  createPartida = async (e) => {
    e.preventDefault();

    // Prevent double-submit — creating an instructor triggers
    // recomputeAsignacionUtilidades which POSTs per stage; a second click
    // duplicates both the instructor row and every utility row.
    if (this.state.isSubmitting) return;

    // Validate form before submitting
    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });
    const headers = getAuthHeaders();

    // Build clean payload with only the fields the backend expects
    const payload = {
      instructor: this.state.instructor,
      miembro_que_asigna: this.state.miembro_que_asigna,
      proyecto_code: this.state.proyecto_code,
      horas: this.state.horas,
      tarifa_hora: this.state.tarifa_hora,
      costo_hora: this.state.costo_hora,
      moneda: this.state.moneda,
      tipo_cambio: this.state.tipo_cambio === "" || this.state.tipo_cambio === null
        ? null
        : Number(this.state.tipo_cambio),
      semanas: this.state.semanas,
      observaciones: this.state.observaciones,
      totalIncome: this.state.totalIncome,
      totalCost: this.state.totalCost,
      profitability: this.state.profitability,
    };

    try {
      console.log("[IngresoFrom] creating instructor with payload:", payload);
      await axios.post(API_URL_instructores, payload, { headers });

      const pcode = this.getProyectoCode();
      console.log("[IngresoFrom] recompute after create with proyecto_code:", pcode);
      if (pcode) {
        await recomputeAsignacionUtilidades(pcode, headers);
      } else {
        console.warn("[IngresoFrom] Skipping recompute: missing proyecto_code");
      }

      this.props.resetState?.();
      this.props.toggle?.();
    } catch (error) {
      console.error("Error adding instructor:", error);

      // Extract detailed error message from backend
      let errorMessage = "Error al agregar el instructor.";

      if (error.response?.data) {
        const errorData = error.response.data;

        // Handle different error response formats
        if (typeof errorData === 'string') {
          errorMessage = errorData;
        } else if (errorData.detail) {
          errorMessage = errorData.detail;
        } else if (errorData.error) {
          errorMessage = errorData.error;
        } else if (errorData.message) {
          errorMessage = errorData.message;
        } else {
          // Handle field-specific validation errors
          const fieldErrors = Object.entries(errorData)
            .map(([field, messages]) => {
              const msgArray = Array.isArray(messages) ? messages : [messages];
              return `${field}: ${msgArray.join(', ')}`;
            })
            .join('; ');

          if (fieldErrors) {
            errorMessage = `Errores de validación: ${fieldErrors}`;
          }
        }
      } else if (error.message) {
        errorMessage = `Error: ${error.message}`;
      }

      this.setState({ errorMessage, isSubmitting: false });
    }
  };

  // ---- EDIT ----
  editPartida = async (e) => {
    e.preventDefault();

    if (this.state.isSubmitting) return;

    // Validate form before submitting
    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });
    const headers = getAuthHeaders();

    // Build clean payload with only the fields the backend expects
    const payload = {
      instructor: this.state.instructor,
      miembro_que_asigna: this.state.miembro_que_asigna,
      proyecto_code: this.state.proyecto_code,
      horas: this.state.horas,
      tarifa_hora: this.state.tarifa_hora,
      costo_hora: this.state.costo_hora,
      moneda: this.state.moneda,
      tipo_cambio: this.state.tipo_cambio === "" || this.state.tipo_cambio === null
        ? null
        : Number(this.state.tipo_cambio),
      semanas: this.state.semanas,
      observaciones: this.state.observaciones,
      totalIncome: this.state.totalIncome,
      totalCost: this.state.totalCost,
      profitability: this.state.profitability,
    };

    try {
      console.log("[IngresoFrom] updating instructor pk:", this.state.pk, "payload:", payload);
      await axios.put(`${API_URL_instructores}${this.state.pk}/`, payload, { headers });

      const pcode = this.getProyectoCode();
      console.log("[IngresoFrom] recompute after edit with proyecto_code:", pcode);
      if (pcode) {
        await recomputeAsignacionUtilidades(pcode, headers);
      } else {
        console.warn("[IngresoFrom] Skipping recompute: missing proyecto_code");
      }

      this.props.resetState?.();
      this.props.toggle?.();
    } catch (error) {
      console.error("Error updating instructor:", error);

      // Extract detailed error message from backend
      let errorMessage = "Error al actualizar el instructor.";

      if (error.response?.data) {
        const errorData = error.response.data;

        // Handle different error response formats
        if (typeof errorData === 'string') {
          errorMessage = errorData;
        } else if (errorData.detail) {
          errorMessage = errorData.detail;
        } else if (errorData.error) {
          errorMessage = errorData.error;
        } else if (errorData.message) {
          errorMessage = errorData.message;
        } else {
          // Handle field-specific validation errors
          const fieldErrors = Object.entries(errorData)
            .map(([field, messages]) => {
              const msgArray = Array.isArray(messages) ? messages : [messages];
              return `${field}: ${msgArray.join(', ')}`;
            })
            .join('; ');

          if (fieldErrors) {
            errorMessage = `Errores de validación: ${fieldErrors}`;
          }
        }
      } else if (error.message) {
        errorMessage = `Error: ${error.message}`;
      }

      this.setState({ errorMessage, isSubmitting: false });
    }
  };

  defaultIfEmpty = (value) => (value === "" ? "" : value);

  handleWheel = (e) => {
    e.preventDefault();
  };

  // Coerce to numbers before math
  calculateTotal = () => {
    const horas = Number(this.state.horas || 0);
    const tarifa_hora = Number(this.state.tarifa_hora || 0);
    const semanas = Number(this.state.semanas || 0);

    if (horas || tarifa_hora || semanas) {
      this.setState({ totalIncome: horas * tarifa_hora * semanas });
    } else {
      this.setState({ totalIncome: "" });
    }
  };

  calculateTotalCost = () => {
    const horas = Number(this.state.horas || 0);
    const costo_hora = Number(this.state.costo_hora || 0);
    const semanas = Number(this.state.semanas || 0);

    if (horas || costo_hora || semanas) {
      // Round only for display: costo_hora may carry full precision when it
      // was derived from a typed total (e.g. 21000 / 9 = 2333.333…).
      this.setState({ totalCost: Math.round(horas * costo_hora * semanas * 100) / 100 });
    } else {
      this.setState({ totalCost: "" });
    }
  };

  // The user knows the closed total ("$21,000 por el instructor"), not the
  // hourly cost. Typing the total back-computes costo_hora WITHOUT rounding,
  // so horas × semanas × costo_hora lands exactly on the total instead of
  // drifting by cents (2333.33 × 9 = 20,999.97).
  onChangeTotalCost = (e) => {
    const raw = e.target.value;
    const horas = Number(this.state.horas || 0);
    const semanas = Number(this.state.semanas || 0);
    const divisor = horas * semanas;
    const total = Number(raw);
    const next = { totalCost: raw === "" ? "" : raw };
    if (raw !== "" && Number.isFinite(total) && divisor > 0) {
      next.costo_hora = total / divisor;
      next.validationErrors = { ...this.state.validationErrors, costo_hora: null };
    }
    this.setState(next, () => this.calculateProfitability());
  };

  calculateProfitability = () => {
    const horas = Number(this.state.horas || 0);
    const tarifa_hora = Number(this.state.tarifa_hora || 0);
    const costo_hora = Number(this.state.costo_hora || 0);
    const semanas = Number(this.state.semanas || 0);

    // Calculate both totals directly from input values to avoid stale state
    const totalIncome = horas * tarifa_hora * semanas;
    const totalCost = horas * costo_hora * semanas;

    if (totalIncome > 0) {
      this.setState({ profitability: (totalIncome - totalCost) / totalIncome });
    } else {
      this.setState({ profitability: "" });
    }
  };

  render() {
    const { errorMessage, instructor, miembro_que_asigna, partners, validationErrors } = this.state;

    const proyectoCodeFrom =
      this.props.proyectoCode ||
      this.props.proyectoCodeSelected ||
      this.props.proyecto_code ||
      this.props.selectedProyecto?.proyecto_code ||
      "";

    const proyectoNameFrom = this.props.proyectoName;
    const h3Style = { color: "blue" };

    const profitabilityDisplay =
      typeof this.state.profitability === "number" && isFinite(this.state.profitability)
        ? `${(this.state.profitability * 100).toFixed(2)}%`
        : "";

    const fxRowCurrency = this.state.moneda || 'USD';
    const fxProjectCurrency = this.props.proyectoMoneda || 'USD';
    const fxCurrency = fxRowCurrency !== 'USD' ? fxRowCurrency : fxProjectCurrency;
    const showTipoCambio = fxRowCurrency !== 'USD' || fxProjectCurrency !== 'USD';

    return (
      <div>
        <h3>{proyectoNameFrom}</h3>
        {proyectoCodeFrom && <h3 style={h3Style}>{proyectoCodeFrom.toUpperCase()}</h3>}

        <div className="form-requirements-note">
          <strong>Nota:</strong> Los campos marcados con <span className="required-asterisk">*</span> son obligatorios.
        </div>

        <Form onSubmit={this.props.instructor ? this.editPartida : this.createPartida}>
          {/* Instructor (type-ahead) */}
          <FormGroup>
            <Label htmlFor="instructor">
              Instructor<span className="required-asterisk">*</span>
            </Label>
            <div className={validationErrors.instructor ? 'react-select-invalid' : ''}>
              <Select
                inputId="instructor"
                options={this.partnerOptions()}
                value={instructor ? { value: instructor, label: instructor } : null}
                onChange={this.handleSelectInstructor}
                isClearable
                placeholder="Escribe para buscar instructor…"
              />
            </div>
            {validationErrors.instructor && (
              <div className="invalid-feedback-custom">{validationErrors.instructor}</div>
            )}
          </FormGroup>

          {/* Partner que provee instructor (type-ahead) */}
          <FormGroup>
            <Label htmlFor="miembro_que_asigna">
              Partner que provee instructor<span className="required-asterisk">*</span>
            </Label>
            <div className={validationErrors.miembro_que_asigna ? 'react-select-invalid' : ''}>
              <Select
                inputId="miembro_que_asigna"
                options={this.partnerOptions()}
                value={
                  miembro_que_asigna
                    ? { value: miembro_que_asigna, label: miembro_que_asigna }
                    : null
                }
                onChange={this.handleSelectMiembroAsigna}
                isClearable
                placeholder="Escribe para buscar partner…"
              />
            </div>
            {validationErrors.miembro_que_asigna && (
              <div className="invalid-feedback-custom">{validationErrors.miembro_que_asigna}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label htmlFor="horas">
              Horas x Semana<span className="required-asterisk">*</span>
            </Label>
            <Input
              type="number"
              name="horas"
              onChange={this.onChange}
              value={this.defaultIfEmpty(this.state.horas)}
              placeholder="Horas"
              className={validationErrors.horas ? 'form-control is-invalid-custom' : 'form-control'}
              inputMode="numeric"
              onWheel={(e) => e.target.blur()}
            />
            {validationErrors.horas && (
              <div className="invalid-feedback-custom">{validationErrors.horas}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label htmlFor="tarifa_hora">
              Precio x Hora<span className="required-asterisk">*</span>
            </Label>
            <Input
              type="number"
              name="tarifa_hora"
              onChange={this.onChange}
              value={this.defaultIfEmpty(this.state.tarifa_hora)}
              placeholder="Ingresa precio x hora"
              className={validationErrors.tarifa_hora ? 'form-control is-invalid-custom' : 'form-control'}
              inputMode="numeric"
              onWheel={(e) => e.target.blur()}
            />
            {validationErrors.tarifa_hora && (
              <div className="invalid-feedback-custom">{validationErrors.tarifa_hora}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label htmlFor="semanas">
              Numero de Semanas<span className="required-asterisk">*</span>
            </Label>
            <Input
              type="number"
              name="semanas"
              onChange={this.onChange}
              value={this.defaultIfEmpty(this.state.semanas)}
              placeholder="Semanas"
              className={validationErrors.semanas ? 'form-control is-invalid-custom' : 'form-control'}
              inputMode="numeric"
              onWheel={(e) => e.target.blur()}
            />
            {validationErrors.semanas && (
              <div className="invalid-feedback-custom">{validationErrors.semanas}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label htmlFor="totalIncome">Total Ingreso:</Label>
            <Input
              type="text"
              name="totalIncome"
              value={
                typeof this.state.totalIncome === "number"
                  ? this.state.totalIncome.toLocaleString()
                  : this.state.totalIncome
              }
              disabled
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="costo_hora">
              Costo x Hora<span className="required-asterisk">*</span>
            </Label>
            <Input
              type="number"
              name="costo_hora"
              onChange={this.onChange}
              value={this.defaultIfEmpty(this.state.costo_hora)}
              placeholder="Ingresa costo x hora"
              className={validationErrors.costo_hora ? 'form-control is-invalid-custom' : 'form-control'}
              inputMode="numeric"
              onWheel={(e) => e.target.blur()}
            />
            {validationErrors.costo_hora && (
              <div className="invalid-feedback-custom">{validationErrors.costo_hora}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label htmlFor="totalCost">Total Costo:</Label>
            <Input
              type="number"
              name="totalCost"
              step="any"
              onChange={this.onChangeTotalCost}
              value={this.state.totalCost === "" || this.state.totalCost == null ? "" : this.state.totalCost}
              placeholder="Calculado, o captura el total cerrado"
              inputMode="decimal"
              onWheel={(e) => e.target.blur()}
              disabled={!(Number(this.state.horas || 0) * Number(this.state.semanas || 0) > 0)}
            />
            <small className="form-text text-muted">
              Se calcula como horas × semanas × costo por hora. Si conoces el total cerrado,
              captúralo aquí y el costo por hora se ajusta solo (sin redondeo).
            </small>
          </FormGroup>

          <FormGroup>
            <Label htmlFor="profitability">Margen:</Label>
            <Input type="text" name="profitability" value={profitabilityDisplay} disabled />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="moneda">Moneda (desde proyecto):</Label>
            <Input
              type="text"
              name="moneda"
              value={this.state.moneda || 'USD'}
              disabled
              style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
            />
            <small className="form-text text-muted">
              La moneda se hereda del proyecto y no se puede cambiar aquí
            </small>
          </FormGroup>

          {showTipoCambio && (
            <FormGroup>
              <Label htmlFor="tipo_cambio">
                Tipo de Cambio ({fxCurrency} por 1 USD):
              </Label>
              <Input
                type="number"
                step="0.0001"
                min="0"
                name="tipo_cambio"
                placeholder={`ej. 17 (déjalo vacío para usar la tasa mensual)`}
                onChange={this.onChange}
                value={this.state.tipo_cambio ?? ""}
              />
              <small className="form-text text-muted">
                {fxRowCurrency !== 'USD'
                  ? 'Opcional. Si lo capturas, esta partida se convierte a USD dividiendo entre este número. Vacío = tasa del mes de inicio del proyecto.'
                  : `Opcional. Si lo capturas, esta partida en USD se convierte a ${fxProjectCurrency} multiplicando por este número. Vacío = tasa del mes de inicio del proyecto.`}
              </small>
            </FormGroup>
          )}

          <FormGroup>
            <Label htmlFor="observaciones">Observaciones:</Label>
            <Input
              type="text"
              name="observaciones"
              onChange={this.onChange}
              value={this.defaultIfEmpty(this.state.observaciones)}
            />
          </FormGroup>

          {errorMessage && <Alert color="danger">{errorMessage}</Alert>}

          <Button color="primary" disabled={this.state.isSubmitting}>
            {this.state.isSubmitting ? (
              <>
                <Spinner size="sm" className="me-2" /> Guardando...
              </>
            ) : (
              'Guardar'
            )}
          </Button>
        </Form>
      </div>
    );
  }
}

export default ProyectoIngresoFrom;